'use es6';

import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { gmail } from '../../../constants/EmailClients';
import { jsx as _jsx } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.wizard.connectInbox.';
const DEFAULT_CLIENT = 'default';
function ConnectLegalDisclaimer({
  selectedClient = DEFAULT_CLIENT
}) {
  const useIncrementalScoping = selectedClient === gmail.key;
  return /*#__PURE__*/_jsx(ExpandableText, {
    scrollable: true,
    toggleable: false,
    maxHeight: 240,
    fadeOutHeight: 80,
    marginBlockEnd: "600",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `${LANG_ROUTE}${selectedClient}${useIncrementalScoping ? '.incrementalScoping' : ''}.legal`
    })
  });
}
export default ConnectLegalDisclaimer;